import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";

const SalesRateForm = (props) => {
  var d = new Date();
  const [itemTypeData, setItemTypeData] = useState([]);
  const [itemTypeId, setItemTypeId] = useState(0);

  const [itemSubTypeData, setItemSubTypeData] = useState([]);
  const [itemSubTypeId, setItemSubTypeId] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [productData, setProductData] = useState([]);

  const offset = currentPage * itemsPerPage;

  const [filterSubTypeList, setFilterSubTypeList] = useState([]);

  const displayedItems =
    productData && productData.slice(offset, offset + itemsPerPage);

  const { sendRequest: getItemType } = useHttp();
  useEffect(() => {
    getItemType(
      {
        url: "/api/fillProductTypesWithoutServices/",
      },
      (res) => {
        if (res) {
          // console.log("Type", res);
          setItemTypeData(res);
        }
      }
    );
  }, [getItemType]);

  const { sendRequest: getItemSubType } = useHttp();
  useEffect(() => {
    getItemSubType(
      {
        url: `/api/productsubitem/?createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          // console.log("subtype", res);

          setItemSubTypeData(res);
        }
      }
    );
  }, [getItemSubType]);

  const itemTypeOnchange = (event) => {
    var itemType = event.target.value;
    setItemTypeId(event.target.value);
    setProductData([]);

    const filterSubTypeList =
      itemSubTypeData &&
      itemSubTypeData.filter(
        (item) => parseInt(item.productTypeId) === parseInt(itemType)
      );

    setFilterSubTypeList(filterSubTypeList);
  };

  const fetchProductData = (itemSubTypeId) => {
    getProductList(
      {
        url: `/api/fillProductListForSalesRate/?productSubTypeId=${itemSubTypeId}&orgId=${localStorage.getItem(
          "orgId"
        )}&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
        //  console.log("Product List", res);
          setProductData(res);
        }
      }
    );
  };

  const { sendRequest: getProductList } = useHttp();

  const itemSubTypeOnchange = (event) => {
    var itemSubTypeId = event.target.value;
    setItemSubTypeId(itemSubTypeId);

    fetchProductData(itemSubTypeId);
  };

  const { sendRequest: postSalesRateCard } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    if (productData.length == 0) {
      toast.error("Product details not found");
      return;
    }

    const data =
      productData &&
      productData.map((item, i) => ({
        salesRateDate: moment(new Date().toISOString().slice(0, 10)).format(
          "DD/MM/YYYY"
        ),
        productId: item.productId,
        salesRate: parseFloat(item.salesRate),
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: parseInt(localStorage.getItem("orgId")),
        serviceId: props.sId,
      }));
  //  console.log(data);

    postSalesRateCard(
      {
        url: "/api/goodsIssuesalesrate/",

        method: "POST",
        body: data,
      },
      (data) => {
      //  console.log(data);
        toast.success(`Sales Rate card detail added"`);
        props.addForm(false);
      }
    );
  };

  useEffect(() => {
    if (props.update && itemSubTypeData.length > 0) {
      setItemTypeId(props.update.productTypeId);

      const filteredSubTypes = itemSubTypeData.filter(
        (item) =>
          parseInt(item.productTypeId) === parseInt(props.update.productTypeId)
      );
      setFilterSubTypeList(filteredSubTypes);

      const subTypeId = props.update.productSubTypeId || 0;
      setItemSubTypeId(subTypeId);

      if (subTypeId) {
        fetchProductData(subTypeId);
      }
    }
  }, [props.update, itemSubTypeData]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Sales Rate Card Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Item Type</label>
                        <select
                          id="ItemTypeNameId"
                          className="form-control"
                          value={itemTypeId}
                          onChange={itemTypeOnchange}
                        >
                          <option>Select</option>
                          {itemTypeData &&
                            itemTypeData.map((x) => (
                              <option
                                key={x.productItemTypeId}
                                value={x.productItemTypeId}
                              >
                                {x.productTypeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Item Sub Type Name </label>
                        <select
                          id="cropNameId"
                          className="form-control"
                          value={itemSubTypeId}
                          onChange={itemSubTypeOnchange}
                        >
                          <option value="0">Select</option>
                          {filterSubTypeList &&
                            filterSubTypeList.map((x) => (
                              <option
                                key={x.productSubTypeId}
                                value={x.productSubTypeId}
                              >
                                {x.productSubTypeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Product Detail </label>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <table className="table table-bordered  text-center">
                      <thead>
                        <tr>
                          <th>Product Item Type </th>
                          <th>Product Item Subtype </th>
                          <th>Product Name </th>
                          <th>Product No </th>
                          <th>Unit </th>

                          <th>Price Per Unit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productData &&
                          productData.map((x, i) => (
                            <tr key={i}>
                              <td>
                                {x.productTypeName}( {x.productTypeNo})
                              </td>

                              <td>
                                {x.productSubTypeName}({x.productSubType})
                              </td>

                              <td>{x.productName}</td>

                              <td>{x.itemId}</td>

                              <td>{x.unitName}</td>

                              <td>
                                <div className="row">
                                  <div className="col-md-2"></div>
                                  <div className="col-md-8">
                                    <input
                                      type={"number"}
                                      id={"PricePerUnit"}
                                      required
                                      className="form-control text-right"
                                      defaultValue={parseFloat(productData[i].salesRate)}
                                      onChange={(e) => {
                                        const value = e.target.value || 0;

                                        if (/^\d*\.?\d{0,4}$/.test(value)) {
                                          const updatedProductData =
                                            productData.map((item, index) =>
                                              index === i
                                                ? { ...item, salesRate: value }
                                                : item
                                            );

                                          setProductData(updatedProductData);
                                         
                                        } else {
                                          e.target.value =
                                            productData[i]?.salesRate || "";
                                        }
                                      }}
                                      step="0.0001"
                                    />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="row">
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default SalesRateForm;
